import { Divider, Stack } from '@mui/material';
import type {
  BackupPolicyType,
  Condition,
  Provider,
  ResourceType,
} from '@repo/api-gw-sdk';

import type { FilterProperty } from '@/types/advanceFilter';

import { ResourceSelectionDynamicEditor } from './resourceSelectionDynamicEditor';
import type { ResourcesScopeType } from './resourceSelectionDynamicViewer';
import { ResourceSelectionManualOverridesEditor } from './resourceSelectionManualEditor';

export const ResourcesSelectionEditor = ({
  condition,
  setCondition,
  supportedProviders,
  supportedProperties,
  supportedResourceTypes,
  conditionTitle,
  allExcludedDescription,
  allIncludedDescription,
  manualOverridesDescription,
  selectedResourceTypes,
  policyType,
  includedResources,
  excludedResources,
  setIncludedResources,
  setExcludedResources,
  resourcesScopeType,
  setResourcesScopeType,
}: {
  condition?: Condition;
  setCondition: (condition?: Condition) => void;
  supportedProviders?: Provider[];
  supportedProperties: FilterProperty[][];
  supportedResourceTypes?: ResourceType[];
  conditionTitle: React.ReactNode;
  allExcludedDescription: string;
  allIncludedDescription: string;
  manualOverridesDescription: string;
  resourcesScopeType: ResourcesScopeType;
  setResourcesScopeType: (resourcesScopeType: ResourcesScopeType) => void;
  includedResources: string[];
  excludedResources: string[];
  setIncludedResources: (includedResources: string[]) => void;
  setExcludedResources: (excludedResources: string[]) => void;
  selectedResourceTypes?: ResourceType[];
  policyType?: BackupPolicyType;
}) => {
  return (
    <Stack
      className='mx-[min(100px,5vw)] mt-[min(60px,3vw)]'
      flexGrow={1}
      minHeight={0}
      direction='row'
      gap='100px'
      justifyContent='space-between'
    >
      <ResourceSelectionDynamicEditor
        condition={condition}
        setCondition={setCondition}
        supportedProviders={supportedProviders}
        supportedProperties={supportedProperties}
        supportedResourceTypes={supportedResourceTypes}
        conditionTitle={conditionTitle}
        allExcludedDescription={allExcludedDescription}
        allIncludedDescription={allIncludedDescription}
        resourcesScopeType={resourcesScopeType}
        setResourcesScopeType={setResourcesScopeType}
        selectedResourceTypes={selectedResourceTypes}
        policyType={policyType}
      />
      <Stack direction='row' gap='100px'>
        <Divider orientation='vertical' flexItem />
        <ResourceSelectionManualOverridesEditor
          description={manualOverridesDescription}
          includeResources={includedResources ?? []}
          excludeResources={excludedResources ?? []}
          setIncludedResources={setIncludedResources}
          setExcludedResources={setExcludedResources}
          supportedProviders={supportedProviders}
          supportedResourceTypes={supportedResourceTypes}
        />
      </Stack>
    </Stack>
  );
};
